// removed by extract-text-webpack-plugin
module.exports = {"container":"_2zxXv","content":"_33iep"};


//////////////////
// WEBPACK FOOTER
// ./app/components/full-screen-window/full-screen-window.scss
// module id = 942
// module chunks = 3 4 5 6 7